/* AddVenueModal — quick "+ Add venue" (name + address) used from the Opponents
 * page, a team's Home venue cell and the Scheduler's game Location picker.
 * Writes the SAME /api/ol-canonical/venues row WP Mgmt ▸ Venues uses (OL builds
 * the slug, the WP push is enqueued). Doc: /app/docs/OPPONENTS_UI.md.
 */
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import bridgeApi from '../admin/bridgeApi';

const FIELDS = [['title', 'Venue name *', 'e.g., Cary Academy Gym'], ['address_1', 'Street', '1500 N Harrison Ave'],
  ['city', 'City', 'Cary'], ['state', 'State', 'NC'], ['zip', 'Zip', '27513'], ['map_url', 'Map link (optional)', 'https://maps.google.com/…']];

export default function AddVenueModal({ open, orgId, initialTitle = '', onClose, onCreated }) {
  const [v, setV] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { if (open) { setV({ title: initialTitle }); setError(''); } }, [open, initialTitle]);

  const save = async () => {
    if (!(v.title || '').trim()) {
      // An address alone was a dead button (AJ 2026-10-20): say what is missing.
      setError('Enter a Venue name — the name players will see, e.g. "Camp Jordan Park". The address goes in Street / City / State / Zip.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const res = await bridgeApi.post('/venues', orgId, { ...v, title: v.title.trim(), name: v.title.trim() });
      onCreated?.(res?.data || res);
      onClose?.();
    } catch (e) { setError(e?.response?.data?.detail || e?.message || 'Could not add the venue'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent className="max-w-md" data-testid="add-venue-modal">
        <DialogTitle>Add venue</DialogTitle>
        <div className="grid grid-cols-2 gap-2">
          {FIELDS.map(([k, l, ph]) => (
            <label key={k} className={`text-xs ${['title', 'address_1', 'map_url'].includes(k) ? 'col-span-2' : ''}`}>
              <span className="text-slate-500">{l}</span>
              <Input value={v[k] || ''} placeholder={ph} onChange={(e) => setV((p) => ({ ...p, [k]: e.target.value }))}
                data-testid={`add-venue-${k}`} />
            </label>
          ))}
        </div>
        {error && <p className="text-xs text-red-500">{error}</p>}
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={onClose}>Cancel</Button>
          <Button size="sm" disabled={saving} onClick={save}
            className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="add-venue-save">Add venue</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
